import PropTypes from 'prop-types'
import { memo, useEffect, useState } from 'react'
import { Element } from '../html/element'
import ItemCheckAll from './ItemCheckAll'
import TreeItem from './TreeItem'
import { filterTreeData, getAllIdTree, getAllParentChecked } from './helper'
import classes from './index.module.scss'
import withWrapperTree from './withWrapperTree'

const Tree = ({
  valueSearch,
  treeData,
  idKey,
  nameKey,
  levelKey,
  doubleClickItem,
  isSearchAbsolute,
  isHaveCheckbox,
  isDefaultCheckAll,
  listChecked,
  setListChecked,
  setListParentChecked,
  isHaveCheckboxAll,
  titleCheckboxAll,
  isActiveSelected,
  isSortKey,
  listHightlight,
  isCheckedWhenClickText,
  listDisabled,
  sortKey,
  defaultOpenLevel1,
  itemDefaultOpen,
  isTextEllipsis,
  lineClamp,
  disabledCheckDbClick,
  onClickItem,
  additionSearchKeys,
  customTreeStyle,
  disableCheckClick,
}) => {
  const [allId, setAllId] = useState([])
  const [keys, setKeys] = useState([])
  const [filterTree, setFilterTree] = useState({})
  const [isReopen, setIsReopen] = useState(false)

  useEffect(() => {
    if (isHaveCheckbox && allId.length === 0) {
      setAllId(getAllIdTree(treeData, idKey))
    }
  }, [treeData])

  useEffect(() => {
    if (isHaveCheckbox && isDefaultCheckAll) {
      setListChecked(allId)
    }
  }, [allId])

  useEffect(() => {
    if (isHaveCheckbox && setListParentChecked) {
      setListParentChecked(getAllParentChecked(treeData, idKey, listChecked))
    }
  }, [listChecked])

  useEffect(() => {
    setKeys(
      isSortKey
        ? Object.keys(treeData).sort()
        : sortKey
        ? Object.keys(treeData).sort((id1, id2) => {
            return String(treeData[id1][sortKey]).localeCompare(
              String(treeData[id2][sortKey]),
            )
          })
        : Object.keys(treeData),
    )
  }, [treeData])

  useEffect(() => {
    setFilterTree(
      filterTreeData(
        treeData,
        nameKey,
        valueSearch,
        isSearchAbsolute,
        defaultOpenLevel1,
        additionSearchKeys,
      ),
    )
    setIsReopen(!isReopen)
  }, [valueSearch, treeData])

  return (
    <Element className="h100">
      {keys.length > 0 && (
        <Element
          elementName="ul"
          className={`${classes.ulFirst} ${
            isHaveCheckbox ? classes.ulFirstCheckbox : ''
          }`}
          style={customTreeStyle}
        >
          {isHaveCheckbox && isHaveCheckboxAll && (
            <ItemCheckAll
              titleCheckboxAll={titleCheckboxAll}
              allId={allId}
              listChecked={listChecked}
              setListChecked={setListChecked}
            />
          )}
          {keys.map((key) => (
            <TreeItem
              key={key}
              item={treeData[key]}
              itemDetail={filterTree[key]}
              idKey={idKey}
              nameKey={nameKey}
              levelKey={levelKey}
              isParentOpen={true}
              doubleClickItem={doubleClickItem}
              isSearchAbsolute={isSearchAbsolute}
              listChecked={listChecked}
              setListChecked={setListChecked}
              isActiveSelected={isActiveSelected}
              isHaveCheckbox={isHaveCheckbox}
              listHightlight={listHightlight}
              isCheckedWhenClickText={isCheckedWhenClickText}
              listDisabled={listDisabled}
              isSortKey={isSortKey}
              sortKey={sortKey}
              isReopen={isReopen}
              itemDefaultOpen={itemDefaultOpen}
              isTextEllipsis={isTextEllipsis}
              lineClamp={lineClamp}
              disabledCheckDbClick={disabledCheckDbClick}
              onClickItem={onClickItem}
              isLevel1
              disableCheckClick={disableCheckClick}
            />
          ))}
        </Element>
      )}
    </Element>
  )
}

Tree.propTypes = {
  valueSearch: PropTypes.string,
  idKey: PropTypes.string,
  nameKey: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  levelKey: PropTypes.string,
  doubleClickItem: PropTypes.func,
  isSearchAbsolute: PropTypes.bool,
  treeData: PropTypes.object.isRequired,
  isHaveCheckbox: PropTypes.bool,
  isDefaultCheckAll: PropTypes.bool,
  listChecked: PropTypes.array,
  setListChecked: PropTypes.func,
  setListParentChecked: PropTypes.func,
  isHaveCheckboxAll: PropTypes.bool,
  titleCheckboxAll: PropTypes.string,
  isActiveSelected: PropTypes.bool,
  isSortKey: PropTypes.bool,
  listHightlight: PropTypes.array,
  isCheckedWhenClickText: PropTypes.bool,
  listDisabled: PropTypes.object,
  sortKey: PropTypes.string,
  defaultOpenLevel1: PropTypes.bool,
  itemDefaultOpen: PropTypes.array,
  isTextEllipsis: PropTypes.bool,
  lineClamp: PropTypes.number,
  disabledCheckDbClick: PropTypes.bool,
}

Tree.defaultProps = {
  valueSearch: '',
  isSearchAbsolute: false,
  isDefaultCheckAll: false,
  isHaveCheckboxAll: false,
  titleCheckboxAll: '',
  listChecked: [],
  setListChecked: () => {},
  isActiveSelected: false,
  isHaveCheckbox: false,
  isSortKey: false,
  listHightlight: [],
  isCheckedWhenClickText: false,
  listDisabled: {},
  defaultOpenLevel1: false,
  isTextEllipsis: true,
  lineClamp: 1,
  disabledCheckDbClick: false,
}

export default withWrapperTree(memo(Tree))
